import { forwardRef } from 'react';
import { cn } from '../../utils';

/**
 * @deprecated
 *
 * ### ⚠️ shadcn 잔재 — 신규 사용 금지.
 *
 * 디자인 토큰·접근성·컨벤션이 반만 맞는 초기 shadcn 원형입니다.
 * 새 import는 6개월 뒤 `git blame`으로 본인을 소환할 커밋이 됩니다.
 * 필요한 기능은 이미 `@zep-us/zus` `TextArea`에 있습니다.
 *
 * ```tsx
 * // ❌
 * import { Textarea } from '@/components/ui/Textarea';
 *
 * // ✅
 * import { TextArea } from '@zep-us/zus';
 * <TextArea.Root value={v}>
 *   <TextArea.Input value={v} onChange={h} />
 * </TextArea.Root>
 * ```
 *
 * @see PR #2365
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  isBig,
  className,
  ...rest
}, ref) => <textarea className={cn('px-md py-[14px] leading-[1.3] rounded-[6px] border-[1px] border-solid border-gray-200 text-default placeholder-gray-400 resize-none', 'focus:outline-primary outline-1', isBig ? 'text-[24px] font-extrabold' : 'text-[18px] font-bold', className)} {...rest} ref={ref} />);
Textarea.displayName = 'Textarea';
type TextareaProps = {
  isBig?: boolean;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;